import _classCallCheck from "/tmp/build_a9c3e3e2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/build_a9c3e3e2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/tmp/build_a9c3e3e2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/tmp/build_a9c3e3e2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _defineProperty from "/tmp/build_a9c3e3e2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _BLOCK_SETTINGS_BY_TY;
import React, { Component } from 'react';
import PropTypes from 'prop-types';
var className = 'price';
export var PRICE_TYPE = {
  DEF: 'def',
  OLD: 'old'
};
var BLOCK_SETTINGS_BY_TYPE = (_BLOCK_SETTINGS_BY_TY = {}, _defineProperty(_BLOCK_SETTINGS_BY_TY, PRICE_TYPE.DEF, {
  className: className,
  tagName: 'span'
}), _defineProperty(_BLOCK_SETTINGS_BY_TY, PRICE_TYPE.OLD, {
  className: "".concat(className, "_old"),
  tagName: 'del'
}), _BLOCK_SETTINGS_BY_TY);
var propTypes = {
  cost: PropTypes.any,
  className: PropTypes.string,
  currency: PropTypes.any,
  currencyFirst: PropTypes.bool,
  prefix: PropTypes.any,
  postfix: PropTypes.any,
  type: PropTypes.oneOf([PRICE_TYPE.DEF, PRICE_TYPE.OLD])
};
var defaultProps = {
  cost: null,
  className: '',
  currency: null,
  currencyFirst: false,
  prefix: null,
  postfix: null,
  type: PRICE_TYPE.DEF
};
var Price = /*#__PURE__*/function (_Component) {
  _inherits(Price, _Component);
  var _super = _createSuper(Price);
  function Price() {
    _classCallCheck(this, Price);
    return _super.apply(this, arguments);
  }
  _createClass(Price, [{
    key: "renderBlock",
    value: function renderBlock(name) {
      return React.createElement('span', {
        key: name,
        className: "".concat(className, "__").concat(name)
      }, this.props[name]);
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      var _this$props = this.props,
        className = _this$props.className,
        type = _this$props.type;
      var t = BLOCK_SETTINGS_BY_TYPE[type] || BLOCK_SETTINGS_BY_TYPE[PRICE_TYPE.DEF];
      var isNotDefault = type !== PRICE_TYPE.DEF && Boolean(BLOCK_SETTINGS_BY_TYPE[type]);
      var classes = [];
      classes.push(BLOCK_SETTINGS_BY_TYPE[PRICE_TYPE.DEF].className);
      if (isNotDefault) {
        classes.push(t.className);
      }
      if (className) {
        classes.push(className);
      }
      return classes.join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        cost = _this$props2.cost,
        currency = _this$props2.currency,
        currencyFirst = _this$props2.currencyFirst,
        postfix = _this$props2.postfix,
        prefix = _this$props2.prefix,
        type = _this$props2.type;
      var t = BLOCK_SETTINGS_BY_TYPE[type] || BLOCK_SETTINGS_BY_TYPE[PRICE_TYPE.DEF];
      var isCostVisible = isDefined(cost);
      var isCurrencyVisible = isDefined(currency) && isCostVisible;
      var r = [];
      if (prefix && isCostVisible) {
        r.push(this.renderBlock('prefix'));
      }
      var priceCost = null;
      if (isCostVisible) {
        priceCost = this.renderBlock('cost');
      }
      var priceCurrency = null;
      if (isCurrencyVisible) {
        priceCurrency = this.renderBlock('currency');
      }
      if (currencyFirst) {
        r.push(priceCurrency);
        r.push(priceCost);
      } else {
        r.push(priceCost);
        r.push(priceCurrency);
      }
      if (postfix && isCostVisible) {
        r.push(this.renderBlock('postfix'));
      }
      return React.createElement(t.tagName, {
        className: this.getClassName()
      }, r);
    }
  }]);
  return Price;
}(Component); // eslint-disable-next-line react/static-property-placement
Price.propTypes = propTypes;
// eslint-disable-next-line react/static-property-placement
Price.defaultProps = defaultProps;

/**
 * @param {*} item
 * @returns {boolean}
 */
function isDefined(item) {
  return item !== undefined && item !== null && item !== '';
}
export default Price;